// src/contextManager/timelineDate.context.tsx
import React, { createContext, useContext, useState } from 'react';

interface TimelineDateContextType {
  selectedDate: Date;
  setSelectedDate: (d: Date) => void;
  viewingTz: string | null;
  setViewingTz: (tz: string | null) => void;
}

const TimelineDateContext = createContext<TimelineDateContextType | null>(null);

export const TimelineDateProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [selectedDate, setSelectedDate] = useState<Date>(new Date());
  const [viewingTz, setViewingTz] = useState<string | null>(null);
  return (
    <TimelineDateContext.Provider value={{ selectedDate, setSelectedDate, viewingTz, setViewingTz }}>
      {children}
    </TimelineDateContext.Provider>
  );
};

export const useTimelineDate = (): TimelineDateContextType => {
  const ctx = useContext(TimelineDateContext);
  if (!ctx) throw new Error('Must be inside TimelineDateProvider');
  return ctx;
};

export const useTimelineDateValue = (): Date => {
  const ctx = useContext(TimelineDateContext);
  if (!ctx) throw new Error('Must be inside TimelineDateProvider');
  return ctx.selectedDate;
};

export const useTimelineDateSetter = (): ((d: Date) => void) => {
  const ctx = useContext(TimelineDateContext);
  if (!ctx) throw new Error('Must be inside TimelineDateProvider');
  return ctx.setSelectedDate;
};

export const useTimelineViewingTz = (): string | null => {
  const ctx = useContext(TimelineDateContext);
  if (!ctx) throw new Error('Must be inside TimelineDateProvider');
  return ctx.viewingTz;
};
